{
  "name": "psmfc-elog",
  "version": "3.2.9",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "eslint . --ext .ts,.html",
    "lint:ci": "eslint . --ext .ts,.html --rule \"prettier/prettier: off\"",
    "lint:fix": "eslint . --ext .ts,.html --fix",
    "format": "prettier \"src/**/*.{ts,html,scss,css,js,json,md}\" --write",
    "format:check": "prettier \"src/**/*.{ts,html,scss,css,js,json,md}\" --check",
    "e2e": "ng e2e",
    "compodoc": "npx compodoc -p tsconfig.app.json",
    "find-deadcode": "ts-prune",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.3",
    "@angular/cdk": "^20.2.7",
    "@angular/common": "^20.3.3",
    "@angular/compiler": "^20.3.3",
    "@angular/core": "^20.3.3",
    "@angular/forms": "^20.3.3",
    "@angular/localize": "^20.3.3",
    "@angular/material": "^20.2.7",
    "@angular/platform-browser": "^20.3.3",
    "@angular/platform-browser-dynamic": "^20.3.3",
    "@angular/router": "^20.3.3",
    "@angular/service-worker": "^20.3.3",
    "@microsoft/applicationinsights-angularplugin-js": "^15.3.6",
    "@microsoft/applicationinsights-web": "^3.3.6",
    "@ng-bootstrap/ng-bootstrap": "^19.0.1",
    "@ng-web-apis/common": "^4.12.0",
    "@ng-web-apis/geolocation": "^4.11.1",
    "@popperjs/core": "^2.10.2",
    "@turf/boolean-point-in-polygon": "^7.2.0",
    "bootstrap": "^5.2.0",
    "guid-typescript": "^1.0.9",
    "jwt-decode": "^4.0.0",
    "material-icons": "^1.11.9",
    "nanoid": "^5.1.5",
    "ngx-online-status": "^2.0.0",
    "ngx-toastr": "^19.0.0",
    "pouchdb": "^9.0.0",
    "pouchdb-upsert": "^2.2.0",
    "rxjs": "^7.8.1",
    "shpjs": "^6.1.0",
    "tslib": "^2.0.0",
    "whirlpool-hash": "^1.1.6",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.4",
    "@angular/cli": "^20.3.4",
    "@angular/compiler-cli": "^20.3.3",
    "@cypress/schematic": "^4.3.0",
    "@schematics/angular": "^21.2.2",
    "@types/jasmine": "~3.6.0",
    "@types/node": "^24.6.2",
    "@types/pouchdb": "^6.4.2",
    "@types/pouchdb-upsert": "^2.2.9",
    "@types/shpjs": "^3.4.7",
    "@typescript-eslint/eslint-plugin": "^8.46.4",
    "@typescript-eslint/parser": "^8.46.4",
    "angular-eslint": "21.0.1",
    "cypress": "15.7.1",
    "eslint": "^9.39.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-prettier": "^5.5.4",
    "jasmine-core": "^3.8.0",
    "jasmine-spec-reporter": "~5.0.0",
    "jsdoc": "^4.0.2",
    "jsdom": "^27.3.0",
    "ts-node": "~8.3.0",
    "ts-prune": "^0.10.3",
    "typescript": "^5.9.3",
    "typescript-eslint": "8.46.4",
    "vitest": "^3.2.4"
  }
}
